import { Injectable } from '@angular/core';
import {  Errors } from './apperror';
import { StorageService } from '../services/storage.service';

@Injectable()
export class ErrorLogService{
    constructor(private storageService: StorageService){}

    generateErrorMsg(err: any){
        if (!navigator.onLine)
            return Errors.NoInternet;

        if (err.name != undefined){
            if (err.name == "TimeoutError"){
                return Errors.TimeOut;
            }
        }

        switch (err.status){
            case 0:
                return Errors.WebServiceDown;
            case 404:
                return Errors.WebServiceNotFound;
        }

        let strErrorCode = err._body.replace(/\"/g,'');
        switch (strErrorCode){
            case Errors.AddSPPParamError.Code:
                return Errors.AddSPPParamError;
            case Errors.TransactionRollBackError.Code:
                return Errors.TransactionRollBackError;
            case Errors.ParamTypeNotMatch.Code:
                return Errors.ParamTypeNotMatch;
            case Errors.ParamNotFound.Code:
                return Errors.ParamNotFound;
            case Errors.SPPMissing.Code:
                return Errors.SPPMissing;
            case Errors.InvalidCredential.Code:
                return Errors.InvalidCredential;
            case Errors.InvalidDatabase.Code:
                return Errors.InvalidDatabase;
            case Errors.InvalidServer.Code:
                return Errors.InvalidServer;
            case Errors.InvalidColumnName.Code:
                return Errors.InvalidColumnName;  
            case Errors.ValueIsLargerThanColumnSize.Code:
                return Errors.ValueIsLargerThanColumnSize;  
            case Errors.PrimaryKeyConstraint.Code:
                return Errors.PrimaryKeyConstraint;  
            case Errors.SPPNotReturnErrorCode.Code:
                return Errors.SPPNotReturnErrorCode;
            case Errors.MismatchCollation.Code:
                return Errors.MismatchCollation;
            case Errors.InvalidXML.Code:
                return Errors.InvalidXML;

            case Errors.OrderNotSubmittedToSAP.Code:
                return Errors.OrderNotSubmittedToSAP;
            case Errors.NoSAPPriceFound.Code:
                return Errors.NoSAPPriceFound;

            case Errors.TokenEmpty.Code:
                return Errors.TokenEmpty;
            case Errors.TokenInvalid.Code:
                return Errors.TokenInvalid;
            case Errors.TokenExpired.Code:
                return Errors.TokenExpired;

            case Errors.UserNotFound.Code:
                return Errors.UserNotFound;
            case Errors.UserNotAvai.Code:
                return Errors.UserNotAvai;
            case Errors.UserDisabled.Code:
                return Errors.UserDisabled;
            case Errors.UserNoSalesrep.Code:
                return Errors.UserNoSalesrep;
            case Errors.UserEmailNotMatch.Code:
                return Errors.UserEmailNotMatch;
            case Errors.MaxRetryReached.Code:
                return Errors.MaxRetryReached;
            case Errors.PwdUsedBefore.Code:
                return Errors.PwdUsedBefore;

            case Errors.ErrorAddingToModel.Code:
                return Errors.ErrorAddingToModel;
            case Errors.UnknownError.Code:
                return {
                    Code: strErrorCode,
                    Title: "Message", 
                    Message: this.storageService.getContactMessage()
                };
            case Errors.OTPNotCorrect.Code:
                return Errors.OTPNotCorrect
            case Errors.ImpersonateEmpty.Code:
                return Errors.ImpersonateEmpty
            default:
                return {
                    Code: strErrorCode,
                    Title: "Server error", 
                    Message: "Unable to locate the error code: '" + strErrorCode + "'. Please contact administrator for support."
                };
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/errorlog.service.ts